// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"f9265792","857":"a0855659"}[chunkId] + ".chunk.js";
};